import { PartnerGroupRules, UserGroupRules } from 'src/graphql';
import { create } from 'zustand';

type PartnerRulesObj = Record<PartnerGroupRules, boolean>;

interface GroupRulesState {
  loading: boolean;
  allRulesDefault: PartnerRulesObj;
  rulesByPartner: Map<number, PartnerRulesObj>;

  setAllRulesDefault: (ids: PartnerGroupRules[]) => void;
  setRulesByPartner: (map: Map<number, PartnerRulesObj>) => void;

  userGroupRules: Record<UserGroupRules, boolean | number[]>;
  setUserGroupRules: (d: Record<UserGroupRules, boolean | number[]>) => void;
}

export const useGroupRulesStore = create<GroupRulesState>((set) => ({
  loading: true,
  allRulesDefault: {} as PartnerRulesObj,
  rulesByPartner: new Map<number, PartnerRulesObj>(),
  userGroupRules: {} as Record<UserGroupRules, boolean | number[]>,

  setAllRulesDefault: (ids) =>
    set(() => ({
      allRulesDefault: ids.reduce((acc, id) => {
        acc[id] = false;
        return acc;
      }, {} as PartnerRulesObj),
    })),

  setRulesByPartner: (map) => set(() => ({ rulesByPartner: new Map(map), loading: false })),
  setUserGroupRules: (d) => set(() => ({ userGroupRules: d, loading: false })),
}));
